import React, { useContext, useEffect, useRef, useState } from "react";
import ViewerContext from "../../context/ViewerContext";
import { ClockRange, ClockStep, CzmlDataSource, JulianDate } from "cesium";
import { createLabel } from "../../helper/cesiumHelper";

const TRAIL_DURATION = 60 * 5; // Define trail duration

const CreateSatelliteDataSource = () => {
  const { satelliteList, latestDataFetchTime } = useContext(ViewerContext);

  useEffect(() => {
    if (satelliteList.length > 0) {
      // console.log(satelliteList);
      const dataSource = getSatelliteDataSource();
      const czmlObj = processSatelliteDataSource(satelliteList);
      dataSource.process(czmlObj);
    }
  }, [satelliteList]);

  const getSatelliteDataSource = () => {
    let satelliteDataSource = viewer.dataSources.getByName(
      "satellite-data-source"
    )[0];
    if (!satelliteDataSource) {
      satelliteDataSource = new CzmlDataSource("satellite-data-source");
      viewer.dataSources.add(satelliteDataSource);
    }
    return satelliteDataSource;
  };

  const processSatelliteDataSource = (dataList) => {
    // const currentTime = new Date();
    const currentTime = viewer.clock.currentTime;
    const currentTimeIso = JulianDate.toIso8601(currentTime);

    const satelliteTimeIso = JulianDate.toIso8601(latestDataFetchTime);

    // //add 10 seconds
    // const endTimeJulian = JulianDate.addHours(
    //   latestDataFetchTime,
    //   1,
    //   new JulianDate()
    // );

    // const satelliteEndTimeIso = JulianDate.toIso8601(endTimeJulian);
    // console.log("satellite time " + satelliteTimeIso);
    // console.log("satellite end time " + satelliteEndTimeIso);
    // console.log("current time " + currentTimeIso);

    // const itemAvailability = currentTimeIso + "/" + satelliteEndTimeIso;

    // 1 hour ago
    const startTimeIso = JulianDate.toIso8601(
      JulianDate.addHours(latestDataFetchTime, -1, new JulianDate())
    );

    //1 minutes later
    const endTimeIso = JulianDate.toIso8601(
      JulianDate.addMinutes(
        latestDataFetchTime,
        1 * viewer.clock.multiplier,
        new JulianDate()
      )
    );

    const clockendTimeIso = JulianDate.toIso8601(
      JulianDate.addHours(
        latestDataFetchTime,
        1,
        new JulianDate()
      )
    );

    const availabilityInterval = startTimeIso + "/" + endTimeIso;
    const documentInterval = startTimeIso + "/" + clockendTimeIso;

    /////////////////////

    const satelliteList = dataList.map((satelliteItem) => {
      const {
        norad_id: satelliteId,
        global_name: satelliteName,
        wgs84_coordinates,
      } = satelliteItem;

      const {
        longitude_degE: lon,
        latitude_degN: lat,
        altitude_m: alt,
      } = wgs84_coordinates;

      const label = createLabel({ name: satelliteName });

      // const heading = satelliteItem.heading_de2 / 100

      const result = {
        id: satelliteId,
        properties: { type: "satellite" },
        availability: availabilityInterval,
        name: satelliteName,
        // description,
        path: {
          material: {
            solidColor: {
              color: {
                rgba: [128, 128, 128, 88],
              },
            },
          },
          width: 2,
          leadTime: 0,
          trailTime: TRAIL_DURATION,
        },
        // Position is an interpolatable property: https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/InterpolatableProperty
        position: {
          forwardExtrapolationType: "HOLD",
          interpolationAlgorithm: "LAGRANGE",
          interpolationDegree: 10,
          epoch: satelliteTimeIso,
          cartographicDegrees: [satelliteTimeIso, lon, lat, alt],
        },
        label: label,
      };

      result.model = {
        gltf: "/models/OceanMission.glb",
        scaleByDistance: {
          nearFarScalar: [2000, 1, 20000, 0.5],
        },
        minimumPixelSize: 32,
      };

      // result.point = {
      //   color: {
      //     rgba: [255, 20, 20, 220],
      //   },
      //   pixelSize: 32,
      //   scaleByDistance: {
      //     nearFarScalar: [2000, 1, 20000, 0.4],
      //   },
      // };

      return result;
    });

    // Construct the CZML object for the path
    return [
      {
        id: "document",
        version: "1.0",
        clock: {
          interval: documentInterval,
          currentTime: currentTimeIso,
          multiplier: viewer.clock.multiplier,
          clockRange: ClockRange.CLAMPED,
          clockStep: ClockStep.SYSTEM_CLOCK_MULTIPLIER,
        },
      },
      ...satelliteList,
    ];
  };

  return <></>;
};

export default CreateSatelliteDataSource;
